import { ApplicationElement, html } from '@beunity/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';
import style from './style.lit.css';

import '@beunity/lit-components/components/img_placeholder/element.js';
import '@beunity/lit-components/components/timeago/element.js';
import '@beunity/lit-components/components/label/element.js';

/**
 * Used for Marketplace item
 *
 * @prop picture - Url picture (optional).
 * @prop placeholderIcon - Icon name (optional).
 * @prop placeholderRounded - Placeholder styling option (optional).
 * @prop name - Main title.
 * @prop info - Additional info (optional).
 * @prop label - Additional info display as label (optional).
 * @prop createdAt - Timestamp (optional).
 * @prop theme - Predefined style (options: primary, secondary, success, info, warning, danger).
 *
 * @cssprop [--text-primary=var(--text-primary)] text color.
 * @cssprop [--dark-bg-secondary] text color for info if theme is not defined.
 * @cssprop [--background-primary=#fff] element background color.
 * @cssprop [--background-secondary=var(--secondary)] label background color.
 * @cssprop [--placeholder-text-primary=var(--gray-600)] placeholder icon color.
 */
export default class ListItem9 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    picture: { type: String },
    placeholderIcon: { type: String },
    placeholderRounded: { type: Boolean, reflect: true },
    name: { type: String },
    info: { type: String },
    theme: { type: String, reflect: true },
    label: { type: String },
    createdAt: { type: Number },
  };

  renderPlaceholder() {
    return html`
      <ef-img-placeholder
        icon=${ifDefined(this.placeholderIcon)}
        picture=${ifDefined(this.picture)}
        alt=${this.name}
        ?rounded=${this.placeholderRounded}>
      </ef-img-placeholder>
    `;
  }

  renderContent() {
    return html`
      <div class="content">
        <h3 class="title">${this.name}</h3>
        ${this.info ? html`<div class="info">${this.info}</div>` : ''}
      </div>
    `;
  }

  renderDetails() {
    return html`
      <div class="details">
        ${this.label
          ? html`<ef-label theme="secondary">${this.label}</ef-label>`
          : ''}
        ${this.createdAt
          ? html` <ef-timeago timestamp=${this.createdAt}></ef-timeago> `
          : ''}
      </div>
    `;
  }

  render() {
    return html`
      ${this.renderPlaceholder()} ${this.renderContent()}
      ${this.label || this.createdAt ? this.renderDetails() : ''}
    `;
  }
}

customElements.get('bu-list-item-9') ||
  customElements.define('bu-list-item-9', ListItem9);
